import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/outputReportGroupDefinitions'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import context from '@/context'
import { localized } from '@/decorators/localized'
import Resx from '@/components/Resx'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody, WhiteBox } from '@/components/Layout'
// import { Button } from '@/components/button'
import { DropDownList } from '@/components/dropDownList'
import { OutputReportGeneratorContent } from './content'
import { GenerateBox } from './generateBox'
import { dialogTypes } from '@/dialogs'
import { Link } from 'react-router-dom'
import getComponentKey from '@/utils/getComponentKey'

// import LoadingIndicator from '@/components/LoadingIndicator'
const initDatasets = (templateDatasets, hasExternalReferences) => {
  const datasets = []

  if (!templateDatasets || !templateDatasets.length) {
    if (hasExternalReferences) {
      datasets.push({ index: null, reportSubmissionGroups: [] })

      return datasets
    }

    return datasets
  }

  for (let i = 0; i < templateDatasets.length; i++) {
    const dataset = templateDatasets[i]

    if (!datasets.find(x => x.index === dataset.datasetNumber)) {
      datasets.push({ index: dataset.datasetNumber, reportSubmissionGroups: [] })
    }
  }

  return datasets
}

@localized()
class OutputReportGenerator extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedDefinition: null,
      datasets: initDatasets(),
      generateBoxKey: getComponentKey()
    }
  }
  confirmIfNeeded = (item, action) => {
    if (this.state.selectedDefinition === null) {
      action()
    } else {
      this.props.openDialog({
        dialogType: dialogTypes.confirm,
        title: 'Common.Confirmation',
        content: 'Reporting.ChangeOutputReportDefinitionConfirmMessage',
        onAction: action
      })
    }
  }
  resetState = () => {
    this.setState({
      selectedDefinition: null,
      datasets: initDatasets(),
      generateBoxKey: getComponentKey()
    })
  }
  onReportSubmissionGroupAdd = (datasetIndex, reportSubmissionGroup) => {
    const newDatasets = this.state.datasets.map(x => {
      if (x.index !== datasetIndex) { return x }

      const newGroups = x.reportSubmissionGroups.filter(group => group.id !== reportSubmissionGroup.id)
      newGroups.push(reportSubmissionGroup)
      return { ...x, reportSubmissionGroups: newGroups }
    })
    this.setState({ datasets: newDatasets })
  }
  onReportSubmissionGroupsBulkAdd = (datasetIndex, added) => {
    const addedIds = added.map(x => x.id)
    const newDatasets = this.state.datasets.map(dataset => {
      if (dataset.index !== datasetIndex) { return dataset }

      const filteredGroups = dataset.reportSubmissionGroups.filter(group => !addedIds.includes(group.id))
      return { ...dataset, reportSubmissionGroups: filteredGroups.concat(added) }
    })

    this.setState({ datasets: newDatasets })
  }
  onReportSubmissionGroupRemove = (datasetIndex, reportSubmissionGroup) => {
    const newDatasets = this.state.datasets.map(x => {
      if (x.index !== datasetIndex) { return x }

      const newGroups = x.reportSubmissionGroups.filter(group => group.id !== reportSubmissionGroup.id)
      return { ...x, reportSubmissionGroups: newGroups }
    })
    this.setState({ datasets: newDatasets })
  }
  onDefinitionChange = (e) => {
    if (e.item !== this.state.selectedDefinition) {
      this.confirmIfNeeded(e.item, () => {
        const item = (e.item || {})

        // TODO: Create a more comprehensive dataset implementation
        this.setState({
          selectedDefinition: e.item,
          datasets: initDatasets(item.templateDatasets, item.hasExternalReferences),
          generateBoxKey: getComponentKey()
        })
      })
    }
  }
  render () {
    const { localize } = this.props
    const { selectedDefinition, datasets } = this.state
    const showGrids = selectedDefinition !== null
    return (
      <Main>
        <MainTop>
          <MainTopTitle>
            <Resx name='Reporting.OutputReportGeneratorTitle' />
          </MainTopTitle>
          <MainTopLeft />
        </MainTop>
        <MainBody>
          <WhiteBox header='Reporting.SelectDefinition'>
            <DropDownList dataSource={context.api.outputReportGroupDefinitionService.getLookup}
              value={selectedDefinition}
              onChange={this.onDefinitionChange}
            />
            {selectedDefinition !== null && <Link to={`/output-report-definitions/${selectedDefinition.id}`} target='_blank'>{localize('Common.Detail')}</Link>}
          </WhiteBox>
          {showGrids && datasets && !!datasets.length && <React.Fragment>
            <OutputReportGeneratorContent
              outputReportGroupDefinition={selectedDefinition}
              onReportSubmissionGroupAdd={this.onReportSubmissionGroupAdd}
              onReportSubmissionGroupsBulkAdd={this.onReportSubmissionGroupsBulkAdd}
              onReportSubmissionGroupRemove={this.onReportSubmissionGroupRemove}
              datasets={datasets}
            />
          </React.Fragment>}
          {selectedDefinition !== null &&
          <GenerateBox key={this.state.generateBoxKey}
            datasets={datasets} outputDefinition={selectedDefinition} onGenerate={this.resetState} />}
        </MainBody>
      </Main>
    )
  }
}

const mapDispatchToProps = {
  get: actionCreators.get,
  openDialog: dialogActions.openDialog
}

export default connect(null, mapDispatchToProps)(OutputReportGenerator)



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGenerator/index.js